import { Component, OnInit, Input } from '@angular/core';
import { SharedDataService } from '../../../services/shared-data.service';
import { CpMarketplaceApiService } from '../../../services/cp-marketplace-api.service';
import { CpAuthenticationService } from '../../../services/cp-authentication.service';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { LOGIN_MESSAGES } from 'src/app/messages';

class ForgotPasswordDetails {
  username: string;
}

class SetNewPasswordDetails {
  username: string;
  newPassword: string;
  confirmPassword: string;
}

@Component({
  selector: 'app-forgot-password-component',
  templateUrl: 'forgot-password-component.html',
  styleUrls: ['forgot-password-component.scss']
})

/**
 * Component for the forgot password form. This page can be open via the Sign in page by clicking on the
 * Forgot Password link.
 */
export class ForgotPasswordFormComponent implements OnInit {
  forgotPasswordDetails = new ForgotPasswordDetails();
  newPasswordDetails = new SetNewPasswordDetails();
  isMailSent: Boolean = false;
  error;
  @Input() loginParams;
  constructor(
    private sharedData: SharedDataService,
    private apiService: CpMarketplaceApiService,
    private authenticationService: CpAuthenticationService,
    private toastr: ToastrService,
    private router: Router
  ) {

  }

  ngOnInit() {
    this.forgotPasswordDetails.username = '';
    this.isMailSent = false;
  }

  submitForgotPasswordDetails(): void {
    if (this.forgotPasswordDetails.username) {
      this.apiService.forgotPassword(this.forgotPasswordDetails.username)
        .subscribe((data: any) => {
          if (data.email_status === 'SUCCESS') {
            // API message
            this.toastr.success(data.message);
            this.forgotPasswordDetails.username = '';
            this.isMailSent = true;
            setTimeout(() => {
              this.router.navigate(['/login']);
            }, 3000);
          }
        },
          error => {
            this.isMailSent = false;

          });
    } else {
      this.toastr.warning(LOGIN_MESSAGES.FORGOT_PASSWORD_INVALID);
    }
  }

  redirectToMainLogin() {
    this.router.navigate(['login']);
  }
}
